import { render, staticRenderFns } from "./Modbus.vue?vue&type=template&id=4052a2f0&"
import script from "./Modbus.vue?vue&type=script&lang=ts&"
export * from "./Modbus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports